import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { buscarEtiquetaPessoaService } from "../../../services/buscarEtiquetaPessoaService";

export const useBuscarEtiquetaPessoa = () => {
  const [etiquetaPessoa, setEtiquetaPessoa] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = async () => {
    setIsLoading(true);
    const data = await buscarEtiquetaPessoaService();

    const formattedData = data.map((item: any) => ({
      id: item.id,
      pessoaId: item.Pessoa.id,        // 🔴 IMPORTANTE
      etiquetaId: item.Etiqueta.id, 
      nomeUsuario:
        item.Pessoa.Usuario.nome + " " + item.Pessoa.Usuario.sobrenome,
      
      etiquetaNome: item.Etiqueta.nome,
      etiquetaCor: item.Etiqueta.cor,
    }));

    setEtiquetaPessoa(formattedData);
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
  }, []);

  // Retorna as variáveis de estado para o componente que utiliza este hook
  return { etiquetaPessoa, isLoading, fetch };
};
